import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/(client)/slcp/(pages)/(list)')({
  component: lazyRouteComponent(
    () => import('../../-components/SlcpListLayout'),
    'SlcpListLayout',
  ),
});
